export class LoginRequestModel {
  username: string = '';
  password: string = '';
}



// WEBPACK FOOTER //
// ./src/app/models/auth/loginRequest.model.ts